// Studio print/export preflight for Trust-configured Standard/Large Text Journeys.
// This is a Trust-local review check only: the national template, illustrations,
// translations and print-only content require their own clinical assurance.
import { clinicalJourneyFingerprint } from './clinicalJourneyReviewSnapshot.js';

export function trustJourneyPrintEligibility(configuration, journeyId, cloudStatus) {
  if (cloudStatus !== 'ready') return {
    allowed:false,
    reason:'A current cloud Trust configuration is required before printing. Local cached drafts can be previewed but not exported.',
    status:'cloud_unverified',
  };
  const configured = configuration?.journeys?.[journeyId];
  if (!configured || configured.included === false) return {
    allowed:false, reason:'This Journey is not enabled in the current Trust configuration.', status:'not_configured',
  };
  const review = configured.clinicalReview;
  if (review?.status !== 'reviewed_accurate' || !review.reviewerUserId || !review.reviewedAt) return {
    allowed:false,
    reason:'A completed Trust clinical review is required before printing this Journey.',
    status:'review_required',
  };
  if (!review.contentFingerprint || review.contentFingerprint !== clinicalJourneyFingerprint(configured)) return {
    allowed:false,
    reason:'The Trust Journey has changed since its clinical review. Request a new review before printing.',
    status:'stale_review',
  };
  return {
    allowed:true,
    status:'current_trust_review',
    reviewerUserId:review.reviewerUserId,
    reviewedAt:review.reviewedAt,
    // Not a statement about national source clinical approval.
    nationalContentApproved:false,
  };
}
